const privacyEffectiveDate =
    process.env
        .NEXT_PUBLIC_PRIVACY_EFFECTIVE_DATE ||
    "2026-10-14";

const formatPrivacyEffectiveDateEn = (
    value
) => {
    const [
        year,
        month,
        day,
    ] = value.split("-");

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    return `${Number(day)} ${
        months[
            Number(month) - 1
        ]
    } ${year}`;
};

const privacyEffectiveDateEn =
    formatPrivacyEffectiveDateEn(
        privacyEffectiveDate
    );

const privacyContentEn = {
    pageTitle:
        "privacy notice",

    introduction:
        "information about the processing and protection of personal data.",

    documentName:
        "Privacy Notice",

    effectiveDate:
        `effective from ${privacyEffectiveDateEn}`,

    translationNotice:
        "This English translation is provided for information purposes only. In the event of any discrepancy, the Hungarian version shall prevail.",

    tableHeaders: [
        "Name",
        "Type",
        "Purpose",
        "Duration",
    ],

    sections: [
        {
            id:
                "data-controller",

            title:
                "The data controller",

            entries: [
                "The controller responsible for processing personal data in connection with the strike.hu website and the services of STRIKE Urban Playground is:",

                {
                    type:
                        "details",

                    items: [
                        "Ötlet Outlet Kft.",
                        "Registered office: 1136 Budapest, Tátra utca 5/A, 1st floor, door 2.",
                        "Company registration number: 01-09-436287",
                        "Tax number: 27510478-2-41",
                        "Represented by: Nyári Zsolt, Managing Director",
                        "E-mail: info@strike.hu",
                        "Phone: +36 30 120 2326",
                        "Website: strike.hu",
                    ],
                },

                "Location of the service:",

                {
                    type:
                        "details",

                    items: [
                        "STRIKE Urban Playground",
                        "1136 Budapest, Pannónia utca 46/A.",
                    ],
                },

                "Hereinafter referred to as the Controller or STRIKE.",
            ],
        },
        {
            id:
                "scope-and-principles",

            title:
                "Scope and principles of this notice",

            entries: [
                "This notice applies to visitors of the strike.hu website, registered users, customers, contact persons, newsletter subscribers and persons visiting the STRIKE venue.",
                "The Controller processes personal data lawfully, fairly and transparently, for specified purposes and only to the extent and for the period necessary. The Controller uses appropriate technical and organisational measures to protect personal data against unauthorised access, alteration, transmission, disclosure, deletion and destruction.",
            ],
        },
        {
            id:
                "registration",

            title:
                "Registration and user accounts",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "E-mail address, selected username or nickname, technical account identifiers, the dates on which the account was created and modified, and technical data required for the secure use of the account.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Purpose of processing",

                    paragraphs: [
                        "Creating, identifying and operating the user account, enabling login, and making previous orders and saved contact and billing details available to the user.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis",

                    paragraphs: [
                        "Performance of a contract under Article 6(1)(b) of the GDPR, or taking steps at the user’s request before entering into a contract.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "Until the account is deleted, but no longer than 5 years after the last login or meaningful account activity. The Controller may send a notification before the inactivity period expires. The user may delete the account at any time through the account settings.",
                        "Deletion of the account does not affect order, billing or legal-claim data that must be retained under applicable law or on another valid legal basis.",
                    ],
                },
            ],
        },
        {
            id:
                "booking-and-orders",

            title:
                "Bookings, orders and ticket purchases",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "Name, e-mail address and phone number of the contact person; booking date; starting and finishing time; number of guests; ordered product or service; order identifier; prices; fees; payment status; electronic ticket and QR code; any coupon or discount code applied; and, where applicable, the gift card code, value, validity period and redemption status associated with the order; and communication relating to the fulfilment of the order.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Purpose of processing",

                    paragraphs: [
                        "Creating the booking and order, processing payment, issuing and delivering the ticket, admission to the venue, providing the service, issuing and administering gift cards and coupons, verifying their validity and managing redemption, preventing unauthorised or repeated use, communication, and handling modifications, complaints and refunds.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis",

                    paragraphs: [
                        "Performance of a contract under Article 6(1)(b) of the GDPR. For data subject to accounting and taxation obligations, compliance with a legal obligation under Article 6(1)(c) of the GDPR.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "5 years following performance of the contract, corresponding to the general limitation period for civil-law claims. Accounting records and the data supporting those records are retained by the Controller for 8 years.",
                    ],
                },
            ],
        },
        {
            id:
                "automatic-form-saving",

            title:
                "Automatic saving and remembering of form data",

            entries: [
                "Contact and billing details entered during the ordering and booking process may be transferred automatically to the STRIKE server as they are entered. Automatic saving is intended to prevent the user from having to enter the same details again following a page refresh, interrupted connection, technical error or later continuation of the ordering process.",
                "Automatic saving may operate for both registered users and customers purchasing as guests. For registered users, the data is linked to the user account. For guests, it is linked to the technical guestJwt guest identifier stored in the browser.",
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "Contact name, e-mail address, phone number, billing name, billing address, tax number where required, and other details entered in the booking and order forms that are required to prepare the order.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Automatic saving of an order in progress",

                    paragraphs: [
                        "The purpose of processing is to operate the ordering or booking process, prevent the loss of entered data and allow the user or guest to continue a process after it has been interrupted.",
                        "The legal basis for processing is performance of a contract under Article 6(1)(b) of the GDPR, or taking steps at the data subject’s request before entering into a contract.",
                        "Personal data automatically saved in connection with an incomplete order is processed by the Controller for no longer than 30 days following the last ordering or booking operation, unless the Controller has another valid legal basis for retaining the data for a longer period as described below.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Automatic saving for registered users",

                    paragraphs: [
                        "Contact and billing details entered during the ordering process may be saved automatically to the registered user’s account. This is intended to operate the user account and ensure that the user does not have to enter the same details again when placing later orders.",
                        "Before registration, the user is informed that the user account also provides for the automatic saving and later retrieval of contact and billing details.",
                        "The legal basis for processing is performance of a contract under Article 6(1)(b) of the GDPR, because automatic data saving is a previously disclosed feature of the registered user account that the user chooses to use.",
                        "The user may view, modify or delete saved contact and billing details at any time through the account settings. The data is retained until deleted by the user or until the account is deleted, but no longer than 5 years after the last meaningful account activity.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Remembering data for guests",

                    paragraphs: [
                        "Where an order is started as a guest, contact and billing details are retained for use with a future order only on the basis of the guest’s separate and voluntary consent.",
                        "During the ordering process, the guest may use an unticked checkbox to request that STRIKE retain the provided details to make completion of the next order easier and faster.",
                        "Refusal to provide consent does not prevent completion of the order or booking and does not affect access to STRIKE services.",
                        "For guests, remembered details are linked to the guestJwt identifier stored in the browser. The details can therefore be retrieved on the same browser and device during the validity period of the identifier. Automatic retrieval may not be possible when using another browser or device, after deleting browser data or after the guestJwt identifier expires.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis and duration of convenient guest-data storage",

                    paragraphs: [
                        "The legal basis for remembering a guest’s contact and billing details for a future order is the guest’s voluntary consent under Article 6(1)(a) of the GDPR.",
                        "STRIKE processes guest details remembered for convenience until consent is withdrawn, but for no longer than 180 days.",
                        "The guest may withdraw consent at any time and request deletion of the saved details through the guest settings or by contacting info@strike.hu.",
                        "Withdrawal of consent does not affect the lawfulness of processing carried out before withdrawal. Deletion of data saved for convenience does not affect data retained on another legal basis in connection with a completed order, invoicing, complaint handling or a legal claim.",
                    ],
                },
            ],
        },
        {
            id:
                "payment-and-invoicing",

            title:
                "Payment and invoicing",

            entries: [
                "Online bank card payments are processed through Stripe. STRIKE does not receive or store the full bank card number, CVC code or other complete card details processed by the payment service provider.",
                "Where payment by bank transfer is made available following separate approval, STRIKE may process the payer’s name, bank account number, transferred amount, date of the transaction and the order or booking reference included in the payment reference in order to verify the payment and match it to the relevant order.",
                "Electronic invoices are issued and delivered through Billingo.",
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "Payment transaction identifier, payment status, amount, currency, order identifier, billing name, address, e-mail address and tax number where required. In the case of a bank transfer, the payer’s name, bank account number, transaction date and payment reference may also be processed.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis and retention period",

                    paragraphs: [
                        "For payments, the legal basis is performance of a contract under Article 6(1)(b) of the GDPR. For invoicing, the legal basis is compliance with a legal obligation under Article 6(1)(c) of the GDPR. Accounting records are retained for 8 years.",
                    ],
                },
            ],
        },
        {
            id:
                "contact-and-complaints",

            title:
                "Contact and complaint handling",

            entries: [
                "The data subject may contact STRIKE using the contact form available on the website, by e-mail at info@strike.hu, by phone or in person. Phone calls are not recorded.",
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "Name, e-mail address, phone number, content of the message or complaint, related order information and any other information provided by the data subject that is required to respond.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis",

                    paragraphs: [
                        "Where the data subject is the contracting party or intends to contract in their own name, necessary communication is based on Article 6(1)(b) of the GDPR. For contacts representing a company or other organisation and for other enquiries, the legal basis is the legitimate interest in responding to the enquiry and handling the matter under Article 6(1)(f) of the GDPR. For consumer complaints that must be processed under applicable law, the legal basis is compliance with a legal obligation under Article 6(1)(c) of the GDPR.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "Simple enquiries are retained for 1 year after the matter is closed, correspondence relating to a contract until the applicable claims become time-barred, and consumer complaints and responses that must be retained under applicable law for 3 years.",
                    ],
                },
            ],
        },
        {
            id:
                "team-building-contact",

            title:
                "Team-building enquiry form",

            entries: [
                "The form on the team-building page is for free enquiries and requests to be contacted. Submitting it and receiving an automatic acknowledgement does not create a booking or any payment obligation.",
                {
                    type:
                        "block",

                    title:
                        "Data processed and provision of data",

                    paragraphs: [
                        "The form requires the company name, contact person's name, e-mail address and phone number, and an estimated group size of 1 to 50 guests. A message of up to 2000 characters is optional. The Controller also processes the submission time, form language, technical enquiry and e-mail identifiers, delivery status and related correspondence.",
                        "Using the form is voluntary; providing these details is not a statutory requirement. The online form cannot be submitted without the details marked with an asterisk; enquiries can also be sent to info@strike.hu. Details are transmitted when submission is initiated, with no server-side draft saved during completion. Please include only information needed to discuss the event.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Purpose of processing",

                    paragraphs: [
                        "Receiving and answering the enquiry, discussing event arrangements, preparing an offer and communicating by e-mail or phone. The system sends an internal notification and an automatic acknowledgement to the enquirer, both containing the submitted details and optional message.",
                        "Technical data is used to check delivery and prevent duplicate sending and automated abuse. Submission does not subscribe the enquirer to a newsletter, and these details are not used for advertising on this basis.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis and legitimate interests",

                    paragraphs: [
                        "For contacts representing a company or other organisation, the legal basis is Article 6(1)(f) of the GDPR: the legitimate interests of STRIKE and the enquiring organisation in responding to the business enquiry and discussing the event.",
                        "Where the enquirer intends to contract in their own name, necessary pre-contractual steps are based on Article 6(1)(b) of the GDPR. Preventing abuse and duplicate sending is based on the legitimate interest in secure operation under Article 6(1)(f) of the GDPR.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "Enquiries that do not result in a booking or contract are retained until the matter is closed and for no more than 1 year afterwards, in line with this Privacy Notice's rule for simple enquiries. Retention after closure serves the legitimate interest in retrieving the correspondence and resolving follow-up questions.",
                        "If an enquiry results in a booking or contract, correspondence needed for its performance is subject to the retention rules for bookings and orders. In a legal dispute, necessary data is retained until the claim is resolved. These rules also apply to copies of correspondence and technical copies retained to resolve delivery failures.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Access and data subject rights",

                    paragraphs: [
                        "STRIKE staff handling the enquiry have access to it. The IT and e-mail infrastructure is operated by Rendszeres Kft., identified in the processors section. E-mails are stored in STRIKE's e-mail system, including the Sent folder; technical copies may also be retained to resolve delivery failures.",
                        "You may object to processing based on legitimate interests on grounds relating to your particular situation by contacting info@strike.hu. The conditions for access, rectification, erasure, restriction and other rights, and options for lodging a complaint, are described in the data subject rights and legal remedies sections.",
                    ],
                },
            ],
        },
        {
            id:
                "newsletter",

            title:
                "Newsletter and direct marketing",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "E-mail address, date of subscription and consent, technical evidence of consent, date of unsubscribing and delivery data relating to sent messages.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Purpose and legal basis of processing",

                    paragraphs: [
                        "Sending news, offers, event information and marketing content. The legal basis for processing is the data subject’s voluntary consent under Article 6(1)(a) of the GDPR.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "Until consent is withdrawn or the data subject unsubscribes. An unsubscribe option is available in every newsletter, and unsubscribing may also be requested at info@strike.hu. Withdrawal of consent does not affect the lawfulness of processing carried out before withdrawal.",
                    ],
                },
            ],
        },
        {
            id:
                "analytics-and-marketing",

            title:
                "Web analytics, advertising and internal measurement",

            entries: [
                "STRIKE may process data for analytics and marketing purposes to analyse use of the website, improve the user experience, measure advertisements and conversions and evaluate the effectiveness of its own campaigns.",
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "URL and domain of the referring website; UTM source, UTM medium, UTM campaign, UTM id, UTM term and UTM content values; technical guest identifier; and technical event data relating to use of the website and conversion measurement.",
                        "The IP address, user agent and arrival time processed for security purposes independently of consent do not form part of the analytics or marketing data set. Their processing is described in the section entitled Technical, security and server logs.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "STRIKE’s internal measurement system",

                    paragraphs: [
                        "STRIKE’s internal measurement system uses the arrival source and UTM campaign parameters to measure how many visits and purchases originate from individual campaigns.",
                        "During internal measurement, arrival and campaign data may be linked to the technical guest identifier. If the visitor later places an order, the system may determine which arrival source or campaign the purchase was associated with.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "External services",

                    paragraphs: [
                        "STRIKE may use Google Analytics, Google Tag Manager, Google Ads, Meta Pixel and Microsoft Clarity to analyse use of the website, improve the user experience and measure advertisements and conversions.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis",

                    paragraphs: [
                        "The legal basis for the use of external analytics and advertising services and for STRIKE’s internal campaign and conversion measurement is the data subject’s voluntary consent under Article 6(1)(a) of the GDPR.",
                        "Analytics processing and internal campaign measurement only start if the data subject has consented to analytics processing. Marketing services are only activated if the data subject has also consented to processing for marketing purposes.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Voluntary nature of consent",

                    paragraphs: [
                        "Refusing consent to analytics or marketing processing does not restrict basic use of the website, registration, booking, ticket purchases or access to STRIKE services.",
                        "The data subject may modify or withdraw consent at any time through the cookie settings. Withdrawal of consent does not affect the lawfulness of processing carried out before withdrawal.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "The retention periods of browser-based analytics and marketing technologies are specified in the section entitled Cookies and browser storage.",
                        "In its own system, STRIKE processes referrer and UTM data linked to a technical guest identifier until consent is withdrawn, but no longer than 1 year from the date on which the data was recorded. After this period, the data is deleted or irreversibly anonymised.",
                    ],
                },
            ],
        },
        {
            id:
                "cookies-and-browser-storage",

            title:
                "Cookies and browser storage",

            entries: [
                "Cookies are small data files placed in the browser. The website may also use sessionStorage or other forms of browser storage. Strictly necessary technologies support the operation of the website, shopping cart, booking process, payment process and consent settings. Analytics and marketing technologies are only activated after the relevant consent has been provided.",
                {
                    type:
                        "table",

                    title:
                        "Strictly necessary cookies",

                    rows: [
                        {
                            name:
                                "guestJwt",

                            type:
                                "cookie",

                            purpose:
                                "Secure identification of the guest session, guest shopping cart and booking process started as a guest, and support for preventing and investigating misuse. The cookie is created upon the first server connection required for the guest process. Without analytics or marketing consent, it does not contain referrer or UTM data.",

                            duration:
                                "180 days",
                        },
                        {
                            name:
                                "__stripe_mid",

                            type:
                                "Stripe cookie",

                            purpose:
                                "Payment security and fraud prevention.",

                            duration:
                                "180 days",
                        },
                        {
                            name:
                                "__stripe_sid",

                            type:
                                "Stripe cookie",

                            purpose:
                                "Payment-session security and fraud prevention.",

                            duration:
                                "approximately 30 minutes",
                        },
                    ],
                },
                {
                    type:
                        "table",

                    title:
                        "Analytics and marketing cookies",

                    rows: [
                        {
                            name:
                                "_ga",

                            type:
                                "Google Analytics cookie",

                            purpose:
                                "Statistical measurement of visitors and website usage.",

                            duration:
                                "180 days",
                        },
                        {
                            name:
                                "_ga_8PFEXZMBR6",

                            type:
                                "Google Analytics cookie",

                            purpose:
                                "Management of the Google Analytics session and measurement state.",

                            duration:
                                "180 days",
                        },
                        {
                            name:
                                "_gcl_au and other Google Ads technologies",

                            type:
                                "Google Ads cookie",

                            purpose:
                                "Measurement of advertising conversions and campaign performance.",

                            duration:
                                "depending on the provider’s settings, generally no longer than 90 days",
                        },
                        {
                            name:
                                "_fbp and other Meta technologies",

                            type:
                                "Meta cookie",

                            purpose:
                                "Measurement of advertising performance and conversions.",

                            duration:
                                "depending on the provider’s settings, generally no longer than 90 days",
                        },
                        {
                            name:
                                "_clck, _clsk and other Clarity technologies",

                            type:
                                "Microsoft Clarity cookie",

                            purpose:
                                "Analysis of website usage and the user experience.",

                            duration:
                                "depending on the technology, until the end of the session or for no longer than 1 year",
                        },
                    ],
                },
                {
                    type:
                        "table",

                    title:
                        "sessionStorage items",

                    rows: [
                        {
                            name:
                                "cookieBannerDone",

                            type:
                                "sessionStorage",

                            purpose:
                                "Stores the status of the cookie settings interface during the current session.",

                            duration:
                                "until the browser tab is closed",
                        },
                        {
                            name:
                                "cookieConsent",

                            type:
                                "sessionStorage",

                            purpose:
                                "Manages the user’s necessary, analytics and marketing consent choices during the current session.",

                            duration:
                                "until the browser tab is closed",
                        },
                        {
                            name:
                                "guestName",

                            type:
                                "sessionStorage",

                            purpose:
                                "Provides a random technical guest identifier to distinguish the session, investigate misuse and allow the guest to refer to their technical identifier when submitting an access or deletion request. The identifier does not itself contain a name, e-mail address or other direct identification data.",

                            duration:
                                "until the browser tab is closed",
                        },
                        {
                            name:
                                "strikePaymentSummary",

                            type:
                                "sessionStorage",

                            purpose:
                                "Displays the booking and payment summary.",

                            duration:
                                "until the browser tab is closed",
                        },
                        {
                            name:
                                "visitorArrival",

                            type:
                                "sessionStorage",

                            purpose:
                                "Temporarily processes the user agent and arrival time to prevent, detect and investigate misuse. Without analytics consent, the item does not contain referrer or UTM data. After analytics consent has been provided, it may be supplemented with the referrer and UTM data required for STRIKE’s internal campaign and conversion measurement.",

                            duration:
                                "until the browser tab is closed or consent is withdrawn",
                        },
                    ],
                },

                "External service providers may use additional technical technologies as their services change. The current list of cookies can also be viewed using the browser’s developer tools. Users may modify their consent at any time through the website’s cookie settings.",
            ],
        },
        {
            id:
                "technical-and-security-logs",

            title:
                "Technical, security and server logs",

            entries: [
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "Random technical guest identifier, IP address, user agent, arrival and request times, visited route, HTTP method, HTTP status, technical browser and device-type data, security events, login and system events, and technical information required to investigate errors and misuse.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Purpose of processing",

                    paragraphs: [
                        "Maintaining the security of the IT system, user accounts, guest shopping carts, bookings and payment processes, and preventing, detecting and investigating automated attacks, unauthorised access, fraud and other misuse.",
                        "The random technical guest identifier allows a guest to refer to their own technical session when submitting an access request, deletion request or report of misuse.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis",

                    paragraphs: [
                        "The legal basis for processing is the Controller’s legitimate interests under Article 6(1)(f) of the GDPR. The Controller has a legitimate interest in operating the service securely, protecting IT systems and users and preventing damage resulting from misuse.",
                        "The Controller does not use security log data processed on the basis of legitimate interests for web analytics, campaign measurement, advertising or profiling. Referrer and UTM data processed for analytics purposes is kept separate and may only be processed on the basis of appropriate consent.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "The Controller retains technical and security log data for no longer than 1 year. Where data is required to investigate a specific security incident, fraud, misuse or legal proceeding, the relevant section of the log may be stored separately until the matter is closed or the related legal claim becomes time-barred.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Right to object",

                    paragraphs: [
                        "The data subject has the right to object, on grounds relating to their particular situation, to processing based on legitimate interests by contacting info@strike.hu. Following an objection, the Controller will cease processing unless it demonstrates compelling legitimate grounds that override the interests, rights and freedoms of the data subject, or the processing is required for the establishment, exercise or defence of legal claims.",
                    ],
                },
            ],
        },
        {
            id:
                "guest-wifi",

            title:
                "Guest Wi-Fi",

            entries: [
                "Guest Wi-Fi operated using STRIKE’s own MikroTik device is available at the STRIKE venue.",
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "The connecting device’s IP address, MAC address and device name, and the times of connection and disconnection.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Purpose and legal basis",

                    paragraphs: [
                        "Maintaining network security and preventing, detecting and investigating misuse. The legal basis is the Controller’s legitimate interests under Article 6(1)(f) of the GDPR.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period",

                    paragraphs: [
                        "STRIKE retains log data for no longer than 1 year. In the event of specific misuse or legal proceedings, the relevant part of the log may be stored separately until the proceedings are concluded.",
                    ],
                },
            ],
        },
        {
            id:
                "cctv",

            title:
                "CCTV surveillance",

            entries: [
                "A CCTV system recording images operates at the STRIKE venue for the purposes of protecting property, personal safety, preventing accidents and investigating incidents. The cameras do not record audio, and their fields of view may only cover areas strictly necessary for achieving these purposes.",
                {
                    type:
                        "block",

                    title:
                        "Data processed",

                    paragraphs: [
                        "The data subject’s image and movement, conduct visible in the recording at the venue, and the location and time of the recording.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Legal basis",

                    paragraphs: [
                        "The legal basis for processing is the Controller’s legitimate interests under Article 6(1)(f) of the GDPR. The Controller has a legitimate interest in maintaining personal and property security and preventing, detecting and investigating accidents, damage and other security events.",
                        "Separate CCTV information describing the location, field of view and purpose of each camera, the retention period of recordings and the persons authorised to access them is available at the venue.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Retention period and access",

                    paragraphs: [
                        "Recordings are deleted automatically after no longer than 3 days if they are not used. In the event of an incident, accident, damage, misuse or request from an authority, the required recording may be isolated and retained until the final conclusion of the matter or until the relevant legal claim becomes time-barred. Recordings may only be accessed by authorised persons in a documented manner.",
                    ],
                },
            ],
        },
        {
            id:
                "photographs-and-videos",

            title:
                "Photographs, videos and event recordings",

            entries: [
                "At certain events, STRIKE may take photographs or video recordings after providing clear information in advance. Recordings may appear on the STRIKE website, social media profiles, advertisements and other marketing materials.",
                "The legal basis for creating and using a recording that prominently and recognisably depicts an individual for marketing purposes is the voluntary consent of the data subject. Group and crowd recordings are subject to the provisions of the Hungarian Civil Code concerning image rights, but the Controller also provides advance notice of recording in such cases.",
                "A minor may only be depicted recognisably with the consent of their legal representative and, where required by the applicable rules, the consent of the minor.",
                "Consent may be withdrawn at any time by contacting info@strike.hu. STRIKE processes recordings until consent is withdrawn, but for no longer than 5 years. Following withdrawal, STRIKE deletes recordings under its control and ceases further use unless another legal basis or legal obligation applies.",
            ],
        },
        {
            id:
                "prize-draws",

            title:
                "Prize draws",

            entries: [
                "STRIKE may organise prize draws from time to time. Separate rules and a short privacy notice are prepared for each prize draw, specifying the categories of data processed, participation requirements, the method used to select and announce the winner, the legal basis for processing and the retention period.",
                "Participation in a prize draw may not be made conditional on mandatory newsletter subscription. Marketing messages may only be sent on the basis of separate, voluntary consent.",
            ],
        },
        {
            id:
                "game-results",

            title:
                "Display of game results",

            entries: [
                "Game results may be displayed on a television results screen at the venue. The system does not use real player names and instead displays random or generic names such as “Player 1” or “Player 2”.",
                "Where a result cannot be linked to the data subject either directly or indirectly, it does not constitute personal data. In the future, STRIKE may only link a result to an identifiable player after providing separate information and establishing an appropriate legal basis.",
            ],
        },
        {
            id:
                "processors-and-recipients",

            title:
                "Processors and recipients",

            entries: [
                "In operating the service, the Controller uses, in particular, the following processors and service providers:",
                {
                    type:
                        "block",

                    title:
                        "Rendszeres Kft.",

                    paragraphs: [
                        "Registered office: 2161 Csomád, Kossuth Lajos út 47.",
                        "Company registration number: 13-09-229423",
                        "Tax number: 22740175-2-13",
                        "Role: IT operations, hosting, database and e-mail infrastructure, backups and technical support. The infrastructure operates on servers located in Germany.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Cloudflare",

                    paragraphs: [
                        "Content delivery, DNS, website security and the prevention of attacks and misuse. Technical data, in particular IP addresses, may be processed when the service is used.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Stripe",

                    paragraphs: [
                        "Online bank card payments, transaction processing, payment security and fraud prevention.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Billingo",

                    paragraphs: [
                        "Issuing, storing and delivering electronic invoices.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "OTP Bank",

                    paragraphs: [
                        "Providing STRIKE’s bank account and processing bank transfers. In the case of payment by bank transfer, the payer’s name, bank account number, transferred amount, transaction date and payment reference may appear among the banking transaction data as part of the operation of the payment service.",
                    ],
                },
                {
                    type:
                        "block",

                    title:
                        "Google, Meta and Microsoft",

                    paragraphs: [
                        "Subject to consent, analytics, conversion measurement, advertising and user-experience analysis services.",
                    ],
                },
                "Newsletters are sent using STRIKE’s own system operating on the server infrastructure identified above.",
                "The Controller may disclose personal data to an authority, court or other authorised body where required by law.",
            ],
        },
        {
            id:
                "international-transfers",

            title:
                "International data transfers",

            entries: [
                "The primary web and database infrastructure operates in Germany within the European Union. When certain global service providers are used, in particular Cloudflare, Google, Meta, Microsoft and Stripe, personal data may also be processed outside the European Economic Area.",
                "Such transfers may only take place subject to safeguards compliant with Chapter V of the GDPR, including an adequacy decision, a valid data-transfer framework or standard contractual clauses adopted by the European Commission. Further information about the safeguards is available in the privacy notice of the relevant service provider.",
            ],
        },
        {
            id:
                "backups-and-security",

            title:
                "Backups and data security",

            entries: [
                "To ensure the availability of the system and data, STRIKE creates backups on a separate server. Backups containing personal data are not stored on privately used computers.",
                "Access to backups is restricted and protected. The backup system retains backups through automatic rotation for no longer than 90 days. Backups are used exclusively for system restoration and are not used by STRIKE for any new processing purpose.",
                "When a deletion request is fulfilled or a retention period expires, the data is deleted from the active system. Data temporarily remaining in a rotating backup is deleted when that backup is overwritten in the normal course of rotation. If the system is restored from a backup, the deletion operations must be applied again.",
            ],
        },
        {
            id:
                "data-subject-rights",

            title:
                "Rights of data subjects",

            entries: [
                "The data subject may request information about the processing of their personal data at info@strike.hu, request access to the data and a copy of it, and request the rectification of inaccurate data.",
                "Where the applicable conditions are met, the data subject may request the deletion of personal data or restriction of its processing, exercise the right to data portability and object to processing based on legitimate interests.",
                "Where processing is based on consent, consent may be withdrawn at any time. Withdrawal does not affect the lawfulness of processing carried out before withdrawal.",
                "The Controller responds to requests without undue delay and no later than one month after receipt. This period may be extended by a further two months under the conditions set out in the GDPR.",
                "The exercise of data-subject rights may not adversely affect the rights and freedoms of another person and does not affect mandatory data-retention obligations imposed by law.",
            ],
        },
        {
            id:
                "legal-remedies",

            title:
                "Legal remedies",

            entries: [
                "If the data subject believes that the processing of their personal data infringes applicable legislation, they may lodge a complaint with the Hungarian National Authority for Data Protection and Freedom of Information.",

                {
                    type:
                        "details",

                    items: [
                        "Hungarian National Authority for Data Protection and Freedom of Information",
                        "Registered office: 1055 Budapest, Falk Miksa utca 9–11.",
                        "Postal address: 1363 Budapest, Pf. 9.",
                        "E-mail: ugyfelszolgalat@naih.hu",
                        "Website: naih.hu",
                    ],
                },

                "The data subject also has the right to seek a judicial remedy. At the data subject’s choice, proceedings may also be initiated before the court having jurisdiction at their place of residence or temporary residence.",
            ],
        },
        {
            id:
                "automated-decision-making",

            title:
                "Automated decision-making and profiling",

            entries: [
                "STRIKE does not use decision-making based solely on automated processing that produces legal effects concerning the data subject or similarly significantly affects them.",
                "Subject to consent, analytics and advertising service providers may carry out profiling within their own systems. Details are provided in the privacy notice of the relevant service provider, and consent may be withdrawn through the cookie settings.",
            ],
        },
        {
            id:
                "notice-amendments",

            title:
                "Amendments to this notice",

            entries: [
                "The Controller may amend this notice where legislation, services or data-processing operations change. The version currently in force is available on the strike.hu website.",
                "In the event of a material change, the Controller will inform users through the website or, where appropriate, by e-mail.",

                {
                    type:
                        "highlight",

                    items: [
                        `Effective from ${privacyEffectiveDateEn}.`,
                    ],
                },
            ],
        },
    ],
};

export default privacyContentEn;